export var AuthResponse;
(function (AuthResponse) {
    /**
     * Token type of the token.
     */
    let token_type;
    (function (token_type) {
        token_type["BEARER"] = "bearer";
    })(token_type = AuthResponse.token_type || (AuthResponse.token_type = {}));
})(AuthResponse || (AuthResponse = {}));
